import script from "./GroupDocsNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupDocsNavigation.vue?vue&type=script&setup=true&lang=js"

import "./GroupDocsNavigation.vue?vue&type=style&index=0&id=63e71972&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e71972"]])

export default __exports__